export default "__VITE_ASSET__O96rymSX__"